import { useState } from "react";
import { MenuItem } from "@mui/material";

import { getTranslateByKey, isShowControlByElementId } from "@/main/services/utils";
import { Controls } from "@/main/services/constants/constantsControl";
import { useThreeDotsPartClaimContext } from "../context";
import OptionEmptySearchClaim from "../optionEmptySearchClaim";
import { isReturnablePart } from "@/main/screens/order/viewOrder/components/infoOrder/utilsInfoOrder";
import ModalReason from "@/main/screens/order/viewOrder/components/modalReason/modalReason";
import { IInfoReasonComponent } from "@/main/screens/order/viewOrder/components/infoOrder/typesInfoOrder";
import KogModalFadeComponent from "@/main/components/modal/ModalFadeComponent";
import { ReasonTypeEnum } from "@/main/services/enum/ReasonEnum";
import { userIsAdmin, userIsBuyer } from "@/main/services/utilsUser";

interface IOptionReturnPartSearchClaimProps {
	bodyshopResponseTime: boolean;
	idStatus: number;
	guidCompany: string;
	guidProcurement: string;
	guidProcurementSupplier: string;
	guidProcurementSupplierItem: string;
	isStripePayment: boolean;
	deliveryBySupplier: boolean;
	refreshGrid: () => void;
}
function OptionReturnPartSearchClaim({
	bodyshopResponseTime,
	idStatus,
	guidCompany,
	isStripePayment,
	guidProcurementSupplierItem,
	guidProcurement,
	guidProcurementSupplier,
	deliveryBySupplier,
	refreshGrid,
}: IOptionReturnPartSearchClaimProps) {
	const { generateIdMenu, closeThreeDotsPartClaim } = useThreeDotsPartClaimContext();

	const INITIAL_INFO_REASON: IInfoReasonComponent = {
		guidSupplierItem: null,
		idReasonType: null,
		titleModal: null,
		open: false,
		guidProcurement: null,
		guidProcurementSupplier: null,
		idProcurementStatusCompany: null,
		deliveryBySupplier: false,
	};

	const [infoReasonComponent, setInfoReasonComponent] = useState<IInfoReasonComponent>(INITIAL_INFO_REASON);
	const [openModalReason, setOpenModalReason] = useState<boolean>(false);

	const showButtonReturn =
		isReturnablePart({
			bodyshopResponseTime,
			idCompanyStatus: idStatus,
			guidCompany,
		}) && !isStripePayment;

	function handleReturnPart() {
		const isBuyerProp = userIsBuyer(guidCompany) || userIsAdmin();
		setInfoReasonComponent({
			guidSupplierItem: guidProcurementSupplierItem,
			open: true,
			titleModal: isBuyerProp
				? getTranslateByKey("information.returnPart")
				: getTranslateByKey("information.returnApprovalConfirm"),
			idReasonType: ReasonTypeEnum.Part,
			guidProcurement,
			guidProcurementSupplier,
			idProcurementStatusCompany: idStatus,
			deliveryBySupplier: deliveryBySupplier,
		});
		setOpenModalReason(true);
		closeThreeDotsPartClaim();
	}

	if (!showButtonReturn) return <OptionEmptySearchClaim option="OptionReturn" />;
	if (!isShowControlByElementId(Controls.IdBtnReturnOrderInClaim))
		return <OptionEmptySearchClaim option="OptionReturn" />;

	return (
		<>
			<MenuItem id={generateIdMenu("return-part")} onClick={handleReturnPart}>
				{getTranslateByKey("information.return")}
			</MenuItem>
			{infoReasonComponent.open && (
				<KogModalFadeComponent open={openModalReason} setOpen={setOpenModalReason}>
					<ModalReason
						title={infoReasonComponent.titleModal}
						idReasonType={infoReasonComponent.idReasonType}
						closeModalReason={setOpenModalReason}
						infoReasonComponent={infoReasonComponent}
						handleSaveCustom={refreshGrid}
						handleUpdateQuoteCountStatus={refreshGrid}
						refreshRowByGuidProcurement={async () => refreshGrid()}
						setResultDataManageStatus={refreshGrid}
					/>
				</KogModalFadeComponent>
			)}
		</>
	);
}

export default OptionReturnPartSearchClaim;
